import 'shared/global';
import Domain from 'helpers/Domain';

if (Domain.isDomestic()) {
    import('components/showBrowse').then((module) => {
        const ShowBrowse = module.default;

        try {
            let __ShowBrowse = new ShowBrowse();
        } catch (e) {
            console.error('ShowBrowse component failed to load.', e.message);
        }
    });
} else if (Domain.isInternational()) {
    import('components/browse').then((module) => {
        const Browse = module.default;

        try {
            let __ShowBrowse = new Browse('shows');
        } catch (e) {
            console.error('ShowBrowse component failed to load.', e.message);
        }
    });
}
